import { Component } from '@angular/core';
import { CmsConfig } from '../../config/cms.config';

@Component({
  selector: 'kion-cms-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

  isLR: boolean;

  constructor(private cmsConfig: CmsConfig) {
    this.isLR = this.cmsConfig.project === 'LR';
  }
}
